"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_RETRY_CONFIG_1 = require("./Constants/DEFAULT_RETRY_CONFIG");
var Retry = /** @class */ (function () {
    function Retry() {
        this.timeout = 0;
        this.failureCount = 0;
        this.config = DEFAULT_RETRY_CONFIG_1.default;
    }
    Retry.prototype.configure = function (config) {
        this.config = config;
    };
    Retry.prototype.onNetworkFailure = function (retryStreamingCallback) {
        if (this.timeoutHandle !== undefined) {
            return;
        }
        this.failureCount += 1;
        var _a = this.config, threshold = _a.threshold, baseDelay = _a.baseDelay, backoffFactor = _a.backoffFactor, fuzzFactor = _a.fuzzFactor;
        if (this.failureCount <= threshold) {
            retryStreamingCallback();
        }
        else {
            if ((this.failureCount - threshold) === 1) {
                this.timeout = baseDelay;
            }
            else {
                this.timeout *= backoffFactor;
            }
            var timeout = this.timeout;
            if (fuzzFactor > 0) {
                var random = Math.random();
                var fuzz = fuzzFactor * baseDelay;
                timeout += Math.floor((random * 2 * fuzz) - fuzz);
            }
            this.setTimeout(retryStreamingCallback, timeout);
        }
    };
    Retry.prototype.onNetworkSuccess = function () {
        this.timeout = 0;
        this.failureCount = 0;
        if (this.timeoutHandle !== undefined) {
            this.clearTimeout();
            this.invokeRetryStreamingCallback();
        }
    };
    Retry.prototype.stop = function () {
        if (this.timeoutHandle !== undefined) {
            this.clearTimeout();
        }
    };
    Retry.prototype.getTimeout = function () {
        return this.timeout;
    };
    Retry.prototype.invokeRetryStreamingCallback = function () {
        var retryStreamingCallback = this.retryStreamingCallback;
        this.retryStreamingCallback = undefined;
        retryStreamingCallback();
    };
    Retry.prototype.setTimeout = function (retryStreamingCallback, timeout) {
        var _this = this;
        this.retryStreamingCallback = retryStreamingCallback;
        this.timeoutHandle = setTimeout(function () {
            _this.timeoutHandle = undefined;
            _this.invokeRetryStreamingCallback();
        }, timeout);
    };
    Retry.prototype.clearTimeout = function () {
        clearTimeout(this.timeoutHandle);
        this.timeoutHandle = undefined;
    };
    return Retry;
}());
exports.default = Retry;
//# sourceMappingURL=Retry.js.map